export default "__VITE_ASSET__BERVnw3H__"